import { createSlice } from '@reduxjs/toolkit';

import { messageAdded } from '../../actions/comboSummaryActions';

const messageSlice = createSlice({
  name: 'message',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(messageAdded, (state, action) => action.payload ?? state);
  },
});

export default messageSlice.reducer;
